export type ImageMime = 'image/jpeg' | 'image/png' | 'image/webp';

/** Image type from magic bytes (OPFS files carry no type). Defaults to JPEG. */
export async function sniffImageMime(blob: Blob): Promise<ImageMime> {
  if (blob.type === 'image/png' || blob.type === 'image/webp' || blob.type === 'image/jpeg') return blob.type;
  const b = new Uint8Array(await blob.slice(0, 12).arrayBuffer());
  if (b[0] === 0x89 && b[1] === 0x50 && b[2] === 0x4e && b[3] === 0x47) return 'image/png';
  if (b[0] === 0x52 && b[1] === 0x49 && b[2] === 0x46 && b[3] === 0x46 && b[8] === 0x57 && b[9] === 0x45)
    return 'image/webp';
  return 'image/jpeg';
}
